export const pageConstants = {
    GET_PAGE_SUCCESS: 'GET_PAGE_SUCCESS',
    GET_MAP_SUCCESS: 'GET_MAP_SUCCESS',


    GET_PAGE_FAILURE: 'GET_PAGE_FAILURE',
    GET_MAP_FAILURE: 'GET_MAP_FAILURE',
}
